// 测试与初始化用：玩家/状态工厂
import type { Hero } from "@/types/heroes";
import type {
  GameState,
  PlayerState,
  Seat,
  Team,
} from "@/types/game";
import type { DeckCard } from "@/types/cards";
import { Rng } from "@/utils/rng";
import { createDrawPile } from "./Deck";

export function makePlayer(
  hero: Hero,
  id: string,
  seat: Seat,
  team: Team,
  isAI: boolean = true
): PlayerState {
  return {
    id,
    seat,
    team,
    hero,
    hp: hero.hp,
    maxHp: hero.hp,
    mp: hero.mp,
    maxMp: hero.mp,
    attack: hero.attack,
    defense: hero.defense,
    magicDefense: hero.magicDefense,
    hand: [],
    equip: {},
    statuses: [],
    isAlive: true,
    isDying: false,
    isAI,
    handLimit: 4,
    hasPlayedAttackThisTurn: false,
    hasUsedSkillThisTurn: false,
    revivalUsed: false,
  };
}

// 4 人 2v2 交叉入座：A1-B1-A2-B2 顺时针 0/1/2/3
// humanSeat: 人类玩家座位（0-3），该座 isAI=false
export function makeInitialState(
  heroes: [Hero, Hero, Hero, Hero],
  deck: readonly DeckCard[],
  seed: number = 1,
  humanSeat: number = -1
): GameState {
  const rng = new Rng(seed);
  let drawPile = createDrawPile(deck, rng);
  const players: PlayerState[] = [
    makePlayer(heroes[0], "p0", 0, "A", 0 !== humanSeat),
    makePlayer(heroes[1], "p1", 1, "B", 1 !== humanSeat),
    makePlayer(heroes[2], "p2", 2, "A", 2 !== humanSeat),
    makePlayer(heroes[3], "p3", 3, "B", 3 !== humanSeat),
  ];
  // 发初始 4 张（不可变更新）
  for (let i = 0; i < 4; i++) {
    const drawn = drawPile.slice(0, 4);
    drawPile = drawPile.slice(4);
    players[i] = { ...players[i], hand: drawn };
  }
  return {
    round: 1,
    players,
    currentPlayerIdx: 0,
    phase: "turn-end",
    drawPile,
    discardPile: [],
    responseWindow: null,
    pickupWindow: null,
    pendingDyingPlayers: [],
    log: [],
    seed,
    turnFlags: {
      hasDrawn: false,
      hasDiscarded: false,
      drawCount: 0,
      attacksPlayed: 0,
      anyCardPlayed: false,
      zhushenComboAvailable: false,
    },
  };
}
